<template>
  <div>
    <!-- Hero Section -->
    <section class="py-20 bg-gradient-dark">
      <div class="container mx-auto px-6 text-center">
        <div class="flex items-center justify-center mb-6">
          <router-link to="/services" class="text-gold-400 hover:text-gold-300 transition-colors duration-300 mr-4">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </router-link>
          <h1 class="text-4xl md:text-6xl font-display font-bold text-gold-400">
            COSMETIC RESTORATIONS
          </h1>
        </div>
        <p class="text-xl text-gold-300 max-w-3xl mx-auto">
          Transform smiles with natural-looking aesthetic solutions and precise diagnostic planning.
        </p>
      </div>
    </section>

    <!-- Products -->
    <section class="py-20">
      <div class="container mx-auto px-6">
        <!-- Diagnostic Wax-Ups -->
        <div class="mb-16">
          <div class="flex items-center mb-10">
            <div class="w-12 h-12 bg-gradient-gold rounded-full flex items-center justify-center mr-6">
              <span class="text-black-900 text-xl font-bold">1</span>
            </div>
            <h2 class="text-3xl md:text-4xl font-display font-bold text-gold-400">
              Diagnostic Wax-Ups
            </h2>
          </div>
          
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800 ml-0 md:ml-18">
            <p class="text-gray-300 text-lg mb-6">
              Visualize the result before treatment begins. Preview tooth shape, alignment, and esthetic outcomes.
            </p>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Visualize the result before treatment begins</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Preview tooth shape, alignment, and esthetic outcomes</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Improve patient communication and case acceptance</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Ensure a predictable and confident treatment plan</span>
              </div>
            </div>
          </div>
        </div>

        <!-- E.MAX Veneers -->
        <div class="mb-16">
          <div class="flex items-center mb-10">
            <div class="w-12 h-12 bg-gradient-gold rounded-full flex items-center justify-center mr-6">
              <span class="text-black-900 text-xl font-bold">2</span>
            </div>
            <h2 class="text-3xl md:text-4xl font-display font-bold text-gold-400">
              E.MAX Veneers
            </h2>
          </div>
          
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800 ml-0 md:ml-18">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Natural translucency</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Exceptional aesthetics</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Strong and durable</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">No-Prep option available</span>
              </div>
              <div class="flex items-start md:col-span-2">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Ideal for full smile makeover cases</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Indirect Composite Veneers -->
        <div class="mb-16">
          <div class="flex items-center mb-10">
            <div class="w-12 h-12 bg-gradient-gold rounded-full flex items-center justify-center mr-6">
              <span class="text-black-900 text-xl font-bold">3</span>
            </div>
            <h2 class="text-3xl md:text-4xl font-display font-bold text-gold-400">
              Indirect Composite Veneers
            </h2>
          </div>
          
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800 ml-0 md:ml-18">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Affordable aesthetic option</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Higher polish & durability</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Faster delivery and easier chair-time</span>
              </div>
              <div class="flex items-start">
                <svg class="w-5 h-5 text-gold-400 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span class="text-gray-300">Great for young patients or budget-sensitive cases</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Back to Services -->
    <section class="py-20">
      <div class="container mx-auto px-6 text-center">
        <router-link to="/services" class="btn-secondary inline-flex items-center">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to All Services
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CosmeticServices'
}
</script>